<template>
  <vs-table v-if="show" ref="table" :params="params" ></vs-table>
</template>

<script>
  import VsTable from "../../_framework/VsTable.vue";
  export default {
    name: "CostCenters",
    components: {
      VsTable
    },
    data() {
      return {
        access: {},
        show: true,
        params: {
          entity: "CostCenters",
          list: [],
          headers: {
            code: {
              title: "کد",
              type: "text"
            },
            CenterTitle: {
              title: "عنوان مرکز",
              type: "text"
            },
          }
        },

      };
    },

  };
</script>

<style scoped>

</style>
